import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue"
import { useAgentsStore } from "@/stores/agents"
import { Agent } from "@/shared/models/agent"

interface Props {
    agent?: Partial<Agent>
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsGeneralAgent',
  props: {
    agent: {}
  },
  setup(__props: any) {

const agentStore = useAgentsStore()

const props = __props

const currentAgent = computed(
    () => agentStore.tableState?.data?.find((agent) => agent._id === props.agent?._id) || props.agent
)
const disabledAgentStyle = computed(() => (currentAgent.value?.status === "disabled" ? "line-through" : ""))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(['text-gray-500', disabledAgentStyle.value])
  }, _toDisplayString(currentAgent.value?.fullName), 3))
}
}

})